<highcharts-chart [Highcharts]="highcharts" 
[options]="chartOptions" class='highchart'>
</highcharts-chart>